import * as React from 'react';

function LogoMain(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8615 23.5459L22.4181 22.1453C20.8966 23.6216 19.063 24.6437 16.9564 25.1737C14.8497 25.7036 12.7431 25.6279 10.6365 25.0222C8.5298 24.4166 6.77426 23.3188 5.29181 21.7289C1.07851 17.1864 1.23456 10.4483 5.44785 6.09509C9.93423 1.47687 17.6196 1.17403 22.4181 5.83011L23.8615 4.4295C18.5949 -0.718685 9.54412 -0.983665 3.9654 4.73234C-1.41826 10.2212 -1.10616 18.9656 4.82366 24.0759C10.7145 29.1484 19.1801 28.2399 23.8615 23.5459ZM21.4033 6.89154L19.5307 8.70855C16.1757 5.41522 10.636 5.90733 7.86614 9.50349C5.29135 12.8725 6.03257 17.6043 9.50464 20.0648C12.9377 22.4875 17.268 21.6169 19.4917 19.3078C19.2576 19.0806 19.0138 18.8535 18.77 18.6264C18.5262 18.3992 18.2823 18.1721 18.0483 17.945C15.5515 20.292 11.7673 19.9134 9.73871 17.5286C7.71009 15.1059 8.0612 11.6612 10.519 9.73061C12.9767 7.80004 16.2927 8.33 18.0483 10.147L16.1367 12.0019H21.4033V6.89154Z"
        fill="white"
      />
    </svg>
  );
}

const MemoLogoMain = React.memo(LogoMain);
export default MemoLogoMain;
